import HistoryDataMsg, { HistoryDataMsgProps } from './history-data-msg';

type HistoryDataNoneProps = Pick<HistoryDataMsgProps, 'size'>;

const HistoryDataNone = ({ size }: HistoryDataNoneProps) => {
  return <HistoryDataMsg size={size}>No data.</HistoryDataMsg>;
};

export default HistoryDataNone;
